import { render } from "./ShipmentList_menu_copy_shipment_id.vue?vue&type=template&id=32ba08c9"
import script from "./ShipmentList_menu_copy_shipment_id.vue?vue&type=script&lang=js"
export * from "./ShipmentList_menu_copy_shipment_id.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__